import React from 'react';
import styles from './PromoImage.module.scss';

interface IPromoImageProps {
  src: string;
  alt: string;
}

const PromoImage = ({ src, alt }: IPromoImageProps) => {
  return <img loading="lazy" className={styles.img_element} src={src} alt={alt} />;
};

export default PromoImage;
